import { InjectionToken } from '@angular/core';

export const BASE_STYLE_ELEMENT_CLASS = new InjectionToken<string>('BASE_STYLE_ELEMENT_CLASS');
